import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class GrupoPermissaoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let validatedpermissoes = true;
        let permissao = model;

        if ( !permissao.descricao ) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }
        
        if ( !validated ){
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }

        if ( !permissao.permiteagro && !permissao.permitevendas && !permissao.permitepromotor ) {
            validated = false;
            validatedpermissoes = false;
        }

        if ( !validatedpermissoes ){
            this.showMessage(new Message('alert', 'msg-necessario-permissao', true));
        }
        
        return validated;
    }

}